export function CircularBar({ value }) {
	const circumference = 100
	const offset = circumference - (value / 100) * circumference

	return (
		<div className='tw-flex tw-items-center tw-justify-center tw-w-32 tw-h-32 tw-relative'>
			<svg className='tw-w-full tw-h-full tw-rotate-[-90deg]' viewBox='0 0 36 36'>
				<circle className='tw-fill-none tw-stroke-gray-200' strokeWidth='2' cx='18' cy='18' r='16' />
				<circle
					className='tw-fill-none tw-stroke-purple-500 tw-transition-all'
					strokeWidth='3'
					strokeDasharray={circumference}
					strokeDashoffset={offset}
					cx='18'
					cy='18'
					r='16'
					strokeLinecap='round'
				/>
			</svg>
			<div className='tw-absolute tw-flex tw-items-center tw-justify-center'>
				<h1 className='tw-text-2xl tw-font-bold tw-m-0 tw-p-1'>
					<span className='tw-text-5xl tw-font-bold tw-mr-1'>{value}</span>%
				</h1>
			</div>
		</div>
	)
}
